<template>
    <main class="page">
        <section class="offerta">
            <div class="offerta__container">
                <div field="text" class="t-text t-text_md" style="">
                    <br />
                    <br />
                    <p style="text-align: center">
                        <strong style="font-size: 22px">
                            <span class="ql-cursor"></span>
                            {{ returnContent.title }}
                        </strong>
                    </p>
                    <br />
                    <div v-html="returnContent.content"></div>
                </div>
            </div>
        </section>
    </main>
</template>

<script setup>
import { ref, onMounted } from "vue";

const config = useRuntimeConfig();
const returnContent = ref({});

const fetchReturnContent = async () => {
    try {
        const response = await $fetch(`${config.public.apiUrl}page/return`);
        returnContent.value = response;
    } catch (error) {
        console.error("Error fetching return content:", error);
    }
};

onMounted(() => {
    fetchReturnContent();
});
</script>

<style scoped>
.t-text {
    line-height: 20px;
}
.text {
    /* font-size: 16px; */
    /* line-height: 24px; */
    /* color: #000; */
}
</style>
